/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  purple_10: '#eedefa',
  purple_20: '#e1c5fa',
  purple_30: '#d5a7fa',
  purple_40: '#c588f7',
  purple_50: '#af64ed',
  purple_60: '#9545d8',
  purple_70: '#8136bf',
  purple_80: '#6d2aa3',
  purple_90: '#5f248f',
  purple_100: '#511f7a',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/purple.js